import { TransactionInstruction, Keypair } from "@solana/web3.js";

export interface IChartInfo {
  DAILY: IDataStructure;
  WEEKLY: IDataStructure;
  MONTHLY: IDataStructure;
}

export interface IDataStructure {
  dataset: IDataSet[];
  comparedTo: IComparedTo;
}

export interface IDataSet {
  label: string;
  value: number;
}

export interface IComparedTo {
  amount: number;
  percentage: number;
}

export interface IPieData {
  labels: string[];
  datasets: {
    label: string;
    data: number[];
    backgroundColor: string[];
    borderColor: string[];
    borderWidth: number;
  }[];
}

export interface IInstructionSet {
  instructions: TransactionInstruction[];
  description: string;
  partialSigner?: Keypair;
  makeMagicEdenaApiCall?: boolean;
}

export class TransactionError extends Error {
  public txid: string;
  constructor(message: string, txid: string) {
    super(message);
    this.txid = txid;
  }
}
